// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1Bwq7","ranges":"BmiRanges_ranges__2d59W"};